import {EditorModes} from "@buildwithflux/core";
import {
    defaultDrawerTabConfiguration,
    DrawerTabConfiguration,
    EditorDrawerTabState,
    LeftEditorDrawerTabState,
} from "@buildwithflux/constants";

import {useFeatureFlags} from "modules/feature_flags/hooks";

export class DrawerTabConfigurationService {
    private getConfiguration(): DrawerTabConfiguration {
        const featureFlagConfig = useFeatureFlags.getState().drawerTabConfiguration;
        return featureFlagConfig || defaultDrawerTabConfiguration;
    }

    getTabsForDrawer(drawer: "left" | "right", editorMode: EditorModes): EditorDrawerTabState[] {
        const config = this.getConfiguration();
        return Object.entries(config)
            .filter(([_, drawerSide]) => drawerSide === drawer)
            .map(([tab, _]) => tab as EditorDrawerTabState)
            .filter((tab) => this.isTabAvailableInMode(tab, editorMode));
    }

    getDrawerForTab(tab: EditorDrawerTabState): "left" | "right" {
        const config = this.getConfiguration();
        return config[tab] || defaultDrawerTabConfiguration[tab];
    }

    private isTabAvailableInMode(tab: EditorDrawerTabState, editorMode: EditorModes): boolean {
        if (tab === LeftEditorDrawerTabState.rules && editorMode !== EditorModes.pcb) {
            return false;
        }
        return true;
    }
}

export const drawerTabConfigurationService = new DrawerTabConfigurationService();
